<div class="logs-container">
  <!-- Header (Fixed) -->
  <div class="logs-header">
    <div class="logs-title">
      <span class="title-text">All Logs</span>
    </div>
    <div class="close-icon" cygovSvgIcon [svgName]="'x-icon-type2'" (click)="closeLogs()"></div>
  </div>

  <!-- Logs Content (Scrollable) -->
  <div class="logs-content" *cygovLoader="isLoading">
    @for (log of logsList; track log.id; let i= $index) {
    <div class="log-entry" [class.first-row]="i === 0 || i === 1">
      <div class="log-header">
        <span class="log-action">{{ log.action }} by:</span>
        <span class="log-user">{{ log.userName }}, </span>
        <span class="log-date">{{ log.date }}</span>
      </div>
      <div class="log-details">
        <div class="log-row">
          <span class="log-label">Origin:</span>
          <span class="log-value" cygovEllipsisTooltip [tooltipText]="log?.origin"
            [tooltipBackgroundColor]="'#030715'" [tooltipPlacement]="'right'">
            {{ log?.origin}}
          </span>
          <span class="log-label">Destination:</span>
          <span class="log-value" cygovEllipsisTooltip [tooltipText]="log?.destination"
            [tooltipBackgroundColor]="'#030715'" [tooltipPlacement]="'right'">{{
            log?.destination}}</span>

        </div>
      </div>
    </div>
    }
  </div>
</div>


<ng-template #globalControlTootTip>
  <div class="tooltip-container lato-12-n-vw">
    <p [ngStyle]="{'margin-top': '5px','margin-bottom': '0px'}">
    </p>
  </div>
</ng-template>